import { render } from "./Municipios.vue?vue&type=template&id=1efb4df8"
import script from "./Municipios.vue?vue&type=script&lang=js"
export * from "./Municipios.vue?vue&type=script&lang=js"

import "./Municipios.vue?vue&type=style&index=0&id=1efb4df8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__